import { Point, Rectangle } from "./geometry";
import { Resource } from "./resource";
import { ResourceStatus } from "./enums";
import { Loader } from "./loader";
import { ScreenRectangle } from "./screen-rectangle";

export class Sprite extends Resource
{
    public rect:ScreenRectangle  = new ScreenRectangle();
    
    // Bitmap width
    public width:number = 0;

    // Bitmap height
    public height:number = 0;
    
    public opacity:number = 1.0;
    public url:string;
    public name:string;
    public image:HTMLImageElement;
    
    public fadeIn:number = 0; // set to a non-zero value if the sprite should fade-in. The value is the opacity change per frame.

    public fadeOut:number = 0; // set to a non-zero value if the sprite shoudl fade-out. The value is the opacity change per frame. Once the opacity reaches zero (or below) the sprite is freed

    get origin() {return this.rect.screenPosition.sub(new Point(this.rect.screenWidth, this.rect.screenHeight).mul(0.5));}

    constructor(url:string)
    {
        super();
        this.rect = new ScreenRectangle();
        this.url = url;
        this.image = new Image();
        this.image.onload = () => {this.onload();}
        this.image.onerror = () => {this.onerror();}
    }

    public update()
    {
        // TODO: check if the sprite is in view and if not, start counting time until its disposal
    }

    public apply()
    {
        if (this.status != ResourceStatus.Loaded)
        {
            this.status = ResourceStatus.Loading;
            this.image.src = this.url;    
        }
    }

    public preload()
    {
        this.name = this.url.substr(this.url.lastIndexOf('/')+1);    
        this.status = ResourceStatus.Preloading;
        Loader.Load(this.url,
            () => {
                this.status = ResourceStatus.Preloaded;
            }, 
            () => {
                this.status = ResourceStatus.Error;
            });
    }

    /**
     * Attemps to unload image data from memory
     */
    public free()
    {
        this.status = ResourceStatus.Empty;
        this.image.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==";
    }

    private onload()
    {
        this.status = ResourceStatus.Loaded;
        if (this.width == 0) this.width = this.image.width;
        if (this.height == 0) this.height = this.image.height;
    }

    private onerror()
    {
        this.status = ResourceStatus.Error;
    }    
}

